import { render, staticRenderFns } from "./ChangeEletricalModal.vue?vue&type=template&id=dddda7b4"
import script from "./ChangeEletricalModal.vue?vue&type=script&lang=js"
export * from "./ChangeEletricalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports